import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface NetworkFailureAnalysisProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.PERFORMANCE_DATA]: string;
    [flowConfig.SITE_KEY]: string;
    [flowConfig.CONSOLIDATED_DATA]: string;
  };
}

export const projectIsNetworkFailureAnalysis = (
  project: Project
): project is NetworkFailureAnalysisProject =>
  project.flow === flowConfig.FLOW_NAME;
